import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from 'js/src/libs/RootState';

const initialState = {
    currentTime: 0,
};
export const preview = createSlice({
    name: 'preview',
    initialState,
    reducers: {
        setCurrentTime: (state, action) => {
            state.currentTime = action.payload;
        },
    },
    selectors: {
        getCurrentTime: (state) => state.currentTime,
    },
});

export const { setCurrentTime } = preview.actions;
export const { getCurrentTime } = preview.getSelectors(
    (state: RootState) => state.clip_creator.preview,
);
